document.addEventListener('DOMContentLoaded', function() {
  if (!window.mz) {
    return
  }
  if (mz.context.filterShow) {
    // placeholder
  }
  function increasePageInUrl(urlString) {
    const url = new URL(urlString);
    const params = new URLSearchParams(url.search);
  
    let currentPage = parseInt(params.get('page')) || 1; // Get current page, default to 1 if not present
    if (mz.app.pagination.last_page == currentPage) {  
      return ''
    }
    currentPage++; 
    params.set('page', currentPage);
  
    url.search = params.toString();
    return url.href; 
  }
  function afterUpdate() {
    const sortDiv = document.querySelectorAll('.mz-horizontal .select')
    const aggsDiv = document.querySelectorAll('.mz-aggs-horizontal')
    if (sortDiv && sortDiv.length > 0 && aggsDiv) {
      aggsDiv[0].insertBefore(sortDiv[0], aggsDiv[0].firstChild)
    }

    // Add "Se flere produkter" link
    const url = increasePageInUrl(window.location.href)
    const generated = document.querySelectorAll('.mz-generated-href')
    const newHref = generated && generated.length > 0 ? generated[0] : document.createElement('a')
    newHref.href = url
    newHref.classList.add('mz-generated-href')
    newHref.classList.add('mz-hidden')
    newHref.innerHTML = '<span load-more-text> Se flere produkter </span>'
    const paginationDiv = document.querySelectorAll('.mz-pagination')
    if (paginationDiv && paginationDiv.length > 0) {
      if (newHref.parentNode) paginationDiv[0].removeChild(newHref)
      if (url != '') {
        paginationDiv[0].insertBefore(newHref, paginationDiv[0].firstChild)
      }
    }

    if (mz.config.scroll) {
      return
    }
    mz.config.scroll = {
      disabled: true
    }
  }
  function closeSearch() {
    document.querySelector('.search-modal__close-button').click()
  }
  if (mz.app && mz.app.$bus) {
    mz.app.$bus.on('after-update', afterUpdate)
  }
  if (mz.suggest && mz.suggest.$bus) {
    mz.suggest.$bus.on('run-query', closeSearch)
  }
})
